module.exports = "<div class=\"redactor__scope\"> <textarea class=\"fallback\" ng-model=\"fallbackTextValue\" ng-change=\"updateModel()\"></textarea> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/redactor/redactor.html
// module id = 1589
// module chunks = 28